import { Award, ShieldCheck, Sparkles } from "lucide-react";

const TIERS = {
  gold: {
    label: "Gold",
    icon: Award,
    ring: "ring-1 ring-amber-300/70",
    bg: "bg-gradient-to-br from-amber-100 to-yellow-200",
    text: "text-amber-800",
    dot: "bg-amber-500",
    tooltip: "Verified, high traffic and fresh offers.",
  },
  silver: {
    label: "Silver",
    icon: ShieldCheck,
    ring: "ring-1 ring-slate-300/70",
    bg: "bg-gradient-to-br from-slate-100 to-slate-200",
    text: "text-slate-700",
    dot: "bg-slate-400",
    tooltip: "Established brand with active offers.",
  },
  bronze: {
    label: "Bronze",
    icon: Sparkles,
    ring: "ring-1 ring-orange-200/80",
    bg: "bg-gradient-to-br from-orange-100 to-amber-100",
    text: "text-orange-800",
    dot: "bg-orange-400",
    tooltip: "Newer or building traction on Cyannect.",
  },
};

export default function TrustBadge({ trust, size = "sm", showLabel = true, testid }) {
  if (!trust || !trust.tier) return null;
  const cfg = TIERS[trust.tier];
  if (!cfg) return null;
  const Icon = cfg.icon;
  const dims = size === "lg"
    ? { pad: "px-2.5 py-1", icon: "w-3.5 h-3.5", text: "text-xs" }
    : { pad: "px-2 py-0.5", icon: "w-3 h-3", text: "text-[10px]" };
  return (
    <span
      title={`${cfg.label} tier · ${trust.score}/100 · ${cfg.tooltip}`}
      className={`inline-flex items-center gap-1 rounded-full font-semibold uppercase tracking-widest ${cfg.pad || dims.pad} ${dims.text} ${cfg.bg} ${cfg.text} ${cfg.ring} shadow-sm`}
      data-testid={testid || `trust-badge-${trust.tier}`}
    >
      <Icon className={dims.icon} />
      {showLabel && cfg.label}
    </span>
  );
}
